import { Product, MainProductType } from './interfaces';

export const isIncompleteDynamicPackage = (product: Product): boolean => {
  if (product.type !== MainProductType.DynamicPackage) return false;

  const isPartial = product.product_data?.isPartialDynamicPackage === true;
  const hasEventContext = product.product_data?.hasEventContext === true;
  const hasEvents = product.subProducts?.some(
    (sp) => sp.type === MainProductType.Event
  );
  const hasHotelOrFlight = product.subProducts?.some(
    (sp) => sp.type === MainProductType.Hotel || sp.type === MainProductType.Flights
  );

  if (isPartial) return true;
  if (hasEventContext && !hasEvents) return true;
  if (hasEvents && !hasHotelOrFlight) return true;

  return false;
};
